import { formatDateStr } from '@intelligence/v3/utils/date';
import {
  LINE_GRID_TOP,
  LEGEND_BOTTOM,
} from '@intelligence/pages/TopCharts/_config/echarts';

const GRANULARITY_X_AXIS_DATE_FORMAT: Partial<Record<IGranularity, string>> = {
  daily: 'YYYY-MM-DD',
  weekly: 'YYYY-MM-DD',
  monthly: 'YYYY-MM',
};

/** 底部 circle 图例行高（itemHeight 8 + fontSize 12） */
const ROBLOX_LINE_CHART_LEGEND_HEIGHT = 14;
/** X 轴区域与图例间距（设计稿 20px） */
const ROBLOX_LINE_CHART_LEGEND_GAP = 20;

/** grid.bottom = 图例高度 + 图例间距 + |LEGEND_BOTTOM| */
export const ROBLOX_LINE_CHART_GRID_BOTTOM =
  ROBLOX_LINE_CHART_LEGEND_HEIGHT +
  ROBLOX_LINE_CHART_LEGEND_GAP +
  Math.abs(LEGEND_BOTTOM);

/** Roblox 折线图 tooltip：挂载到 body 避免被裁切，同时限制交互避免残留双弹窗 */
const ROBLOX_LINE_CHART_TOOLTIP = {
  appendToBody: true,
  confine: false,
  extraCssText: 'z-index: 9999999;',
  hideDelay: 0,
  transitionDuration: 0,
  enterable: false,
  triggerOn: 'mousemove',
} as const;

/** Roblox 折线图 X 轴与 grid 配置：避免右侧日期被裁切 */
export const buildRobloxLineChartOption = (
  lineOption: Record<string, any> | undefined,
  granularity: IGranularity = 'daily',
): Record<string, any> | undefined => {
  if (!lineOption) {
    return lineOption;
  }

  const dateFormatter = GRANULARITY_X_AXIS_DATE_FORMAT[granularity] || 'YYYY-MM-DD';
  const needsExtraRightPadding = granularity === 'monthly' || granularity === 'weekly';
  const existingXAxis = lineOption.xAxis || {};
  const existingAxisLabel = existingXAxis.axisLabel || {};

  return {
    ...lineOption,
    tooltip: {
      ...(lineOption.tooltip || {}),
      ...ROBLOX_LINE_CHART_TOOLTIP,
    },
    grid: {
      ...lineOption.grid,
      top: LINE_GRID_TOP,
      bottom: ROBLOX_LINE_CHART_GRID_BOTTOM,
      right: needsExtraRightPadding ? 48 : 36,
      containLabel: true,
    },
    xAxis: {
      ...existingXAxis,
      boundaryGap: true,
      axisLabel: {
        ...existingAxisLabel,
        showMaxLabel: true,
        showMinLabel: true,
        formatter: (value: string) => formatDateStr(value, dateFormatter) || value,
      },
    },
  };
};
